import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoadingSpinner from '../common/LoadingSpinner';
import { supabase } from '../../config/supabase';

const AuthGuard = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [showForceLogout, setShowForceLogout] = useState(false);

  // Timer to show "Force Logout" if loading takes too long
  useEffect(() => {
    let timer;
    if (loading) {
      timer = setTimeout(() => {
        setShowForceLogout(true);
      }, 4000); // Show after 4 seconds
    } else {
      setShowForceLogout(false);
    }
    return () => clearTimeout(timer);
  }, [loading]);

  const handleForceLogout = async () => {
    console.log('🔴 Force logging out...');
    await supabase.auth.signOut();
    window.location.reload();
  };

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
        <LoadingSpinner size="large" />
        <p className="mt-4 text-gray-600 font-medium">Authenticating...</p>
        
        {showForceLogout && (
          <div className="mt-8 text-center animate-fade-in">
            <p className="text-sm text-red-500 mb-3">
              Taking longer than expected?
            </p>
            <button
              onClick={handleForceLogout}
              className="px-4 py-2 bg-white border border-red-300 text-red-600 rounded-md text-sm hover:bg-red-50 transition-colors shadow-sm"
            >
              Force Log Out
            </button>
            <p className="mt-4 text-xs text-gray-400 max-w-xs mx-auto">
              If this persists, run the <code>emergency-rls-fix.sql</code> in your Supabase SQL Editor.
            </p>
          </div>
        )}
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default AuthGuard;